var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlobTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 337,
    height: 339,
    viewBox: "0 0 337 339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-mode-selection-illustration"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 337,
    height: 339
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mode-selection-illustration",
    clipPath: "url(#clip-mode-selection-illustration)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-559.267 -116.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1194.36,518.316c81.86,86.64,55.54,283.1,32.14,370.5L1706.07,58.18,540.708-1042.88,4.267-838.216c21.1,67.15,116.142,230.967,327.478,349.044,264.171,147.6,51.114,324.848,220.88,597.6S1092.04,410.017,1194.36,518.316Z",
    fill: "#174374"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobTopRight);
export default __webpack_public_path__ + "static/media/blob-top-right.8e2203443f281d0300be3723fc09b48e.svg";
export { ForwardRef as ReactComponent };